import {Component} from '@angular/core';
import {AbstractComponent} from "../abstract.component";

@Component({
    selector: 'app-horizontal-box-list-item',
    templateUrl: './horizontal-box-list-item.component.html',
    styleUrls: ['./horizontal-box-list-item.component.scss'],
    standalone: false
})
export class HorizontalBoxListItemComponent extends AbstractComponent {
   constructor() {
       super();
   }
}
